/**
 * Rollen (SPEC 2). Die Rolle `viewer` wurde bewusst weggelassen — bei vier bis
 * sechs Familienmitgliedern gibt es keinen belastbaren Nur-Lese-Fall, und jede
 * zusaetzliche Rolle kostet eine Pruefung auf jedem mutierenden Endpoint.
 */
export const ROLES = ['admin', 'member'];
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/** Rolle innerhalb eines Boards. Unabhaengig von der globalen Rolle. */
export const BOARD_ROLES = ['owner', 'member'];
/** Prioritaet 0–3 (SPEC 9.1). */
export const PRIORITIES = {
    none: 0,
    low: 1,
    medium: 2,
    high: 3,
};
export const PRIORITY_LABELS = {
    0: 'keine',
    1: 'niedrig',
    2: 'mittel',
    3: 'wichtig',
};
/** Ein globaler Admin darf alles; ein Member nur, wo er Board-Mitglied ist. */
export function canAdministrate(role) {
    return role === 'admin';
}
/** Farbschema-Wahl pro Nutzer (SPEC 8.3). */
export const COLOR_SCHEMES = ['light', 'dark', 'system'];
export const COLOR_SCHEME_LABELS = {
    light: 'Hell',
    dark: 'Dunkel',
    system: 'Systemeinstellung',
};
/**
 * Labelfarben (SPEC 9.1). Gespeichert wird der NAME, nicht der Farbwert —
 * sonst haette ein Label im Dark Mode dieselbe Farbe wie im Hellthema, und
 * Akzeptanzkriterium A11 waere ausgehebelt.
 */
export const LABEL_COLORS = ['rose', 'amber', 'forest', 'ocean', 'plum', 'slate'];
//# sourceMappingURL=roles.js.map